import React from "react";
import styled, { css } from "styled-components";
const indicatorClassName = "nav-item-state-indicator";
const indicatorPseudoElement = "::before";
export const itemStateIndicatorContainerSelector = `.${indicatorClassName}`;
export const itemStateIndicatorSelector = `${itemStateIndicatorContainerSelector}${indicatorPseudoElement}`;
export const hoverIndicatorStyles = (theme) => css`
  ${itemStateIndicatorSelector} {
    border-color: ${theme.colors.gray[70]};
  }
`;
export const activeIndicatorStyles = (theme) => css`
  ${itemStateIndicatorSelector} {
    border-color: ${theme.colors.gray[50]};
  }
`;
const Container = styled.div`
  display: inline;
  position: relative;

  &${indicatorPseudoElement} {
    content: ' ';
    position: absolute;
    border-bottom: 1px solid transparent;
    left: 0;
    width: 100%;
    bottom: -4px;
  }
`;
const NavItemStateIndicator = ({ children }) => /* @__PURE__ */ React.createElement(Container, { className: indicatorClassName }, children);
export default NavItemStateIndicator;
